import React from "react";
import { Layout } from "..";
import { Reviews } from "../../components";
import { Container } from "./styled";

function Impuestos() {
  return (
    <Layout>
      <Container>
        <div className="hero-section" id="contactForm">
          <div className="hero-section-content">
            <div className="hero-section-content-text">
              <h1>Servicios Contables Impositivos</h1>
              <p>Somos tu Aliado Estratégico en Contabilidad e Impuestos.</p>
            </div>
            <div className="hero-section-content-form">
              <form action="https://formsubmit.co/your@email.com" method="POST">
                <div className="personal-data">
                  <input
                    placeholder="NOMBRE COMPLETO"
                    type="text"
                    name="nombre"
                    required
                  />
                  <input placeholder="MAIL" type="email" name="mail" required />
                </div>
                <input
                  placeholder="ASUNTO"
                  type="text"
                  name="asunto"
                  required
                />
                <input
                  placeholder="MENSAJE"
                  className="message"
                  type="text"
                  name="mensaje"
                  required
                />
                <button type="submit" className="btn-primary">
                  CONSULTAR
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="cta-section">
          <h1>El mejor Servicio Mensual adaptado a vos</h1>
          <hr className="separation-line" />
          <h3>¡Nosotros nos encargamos de tus impuestos!</h3>
          <p>
            Ofrecemos una amplia gama de servicios contables impositivos
            diseñados para apoyar tu negocio en cada etapa. Desde liquidaciones
            de IVA, Ingresos Brutos y Ganancias hasta asesoramiento
            personalizado, estamos aquí para simplificar tus obligaciones
            fiscales y ayudarte a crecer con confianza.
          </p>
          <a href="#contactForm" className="btn-primary">
            CONSULTANOS
          </a>
        </div>
        <div className="home-options-container">
          <div className="image-container">
            <img
              src="../../assets/services-1.jpg"
              loading="lazy"
              alt="bussines images"
            />
          </div>
          <div className="about-container">
            <h2>Nuestros Servicios Contables Impositivos</h2>
            <ul>
              <li>
                Inscripciones para el inicio de la actividad Personas Físicas
                (Monotributo, IVA, Ganancias, Autónomos), o Personas Jurídicas:
                Sociedades, Asociaciones, Fundaciones, y otras formas de
                asociaciones.
              </li>
              <li>Asesoramiento impositivo integral.</li>
              <li>
                Solicitud de certificado de retención para residentes del
                exterior.
              </li>
              <li>Regularizaciones impositivas, previsionales y aduaneras.</li>
              <li>
                Liquidaciones impositivas de: Personas Físicas y Jurídicas.
              </li>
              <li>Recategorización Monotributistas.</li>
              <li>Exclusiones de Monotributistas.</li>
              <li>
                Atención de requerimientos de organismos de fiscalización y
                control.
              </li>
              <li>Actualización permanente en novedades impositivas.</li>
            </ul>
          </div>
        </div>
        <div className="home-options-container reversed">
          <div className="image-container">
            <img
              src="../../assets/services-2.jpg"
              loading="lazy"
              alt="bussines images"
            />
          </div>
          <div className="about-container">
            <h2>¿Querés asesorarte previamente?</h2>
            <p>
              Iniciar en el ámbito contable e impositivo puede tener sus
              desafíos. En nuestro estudio, no solo ofrecemos servicios
              contables impositivos de primer nivel, sino que también estamos
              aquí para asesorarte.
            </p>
            <p>
              Antes de que te comprometas con un servicio mensual, te brindamos
              toda la orientación que necesitás. Y si estás buscando realizar un
              trámite de inscripción en AFIP, ¡también te cubrimos!
            </p>
            <a href="#contactForm" className="btn-primary ">
              CONSULTANOS
            </a>
          </div>
        </div>
        {/* <Reviews /> */}
      </Container>
    </Layout>
  );
}

export default Impuestos;
